<template>
  <div v-show="showfilter" class="cnd-filter-column">
    <div
      v-show="selectedList.length || !showfilterItems"
      class="item selected"
    >
      <div class="item-label">{{ $t('components.selected') }}</div>
      <div class="item-content">
        <template v-for="item in selectedList">
          <el-tag
            :key="item.dateKey"
            size="mini"
            closable
            @close="() => multipleDelte(item)"
          >
            {{ item[item.sourceName] }}
          </el-tag>
        </template>
      </div>
      <div class="item-footer">
        <el-link
          v-if="localStorageKey"
          size="mini"
          :underline="false"
          @click="saveFilterForm"
        >
          {{ hasLocalSotrage ? $t('grid.others.clearScreening') : $t('grid.others.saveFiltering') }}
        </el-link>
        <el-link
          size="mini"
          :underline="false"
          @click="clearFilterForm"
        >
          {{ $t('components.clearTheSelected') }}
        </el-link>
        <el-link
          size="mini"
          :underline="false"
          @click="showfilterItems = !showfilterItems"
        >
          {{ showfilterItems ? $t('components.collapse') : $t('grid.others.more') }}
        </el-link>
      </div>
    </div>
    <template v-if="showfilterItems">
      <div
        v-for="(column, index) in dataSource"
        :key="index"
      >
        <div
          v-if="(column.type && column.type === 'date') || (column.dataSource && column.dataSource.length)"
          :class="['item', {
            'expanded': !column.expanded
          }]"
        >
          <div class="item-label">{{ column.label }}</div>

          <template v-if="column.type !== 'date'">
            <div
              class="item-content"
              :style="{
                height: !column.expanded ? '100%' : '38px'
              }"
            >
              <div ref="columnWrapper" class="item-wrapper">
                <template
                  v-for="item in column.dataSource"
                >
                  <el-tag
                    :key="item[column.sourceValue] + item[column.sourceName]"
                    :ref="item[column.sourceValue] + item[column.sourceName]"
                    size="mini"
                    :effect="isSelect(column, item) ? 'dark' : 'light'"
                    @click="() => handleSelect(!isSelect(column, item), item, column, item[column.sourceValue] + item[column.sourceName])"
                  >
                    {{ item[column.sourceName] }}
                  </el-tag>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="item-content spec">
              <el-date-picker
                v-model="filterForm[column.valueKey]"
                :start-placeholder="$t('grid.others.startDate')"
                :end-placeholder="$t('grid.others.endDate')"
                type="daterange"
                size="mini"
                :default-time="['00:00:00', '23:59:59']"
                @change="val => handleChangeTime(val, column.valueKey)"
              />
            </div>
          </template>
          <div
            v-if="typeof column.expanded === 'boolean' && heightList[index] > 38"
            class="item-footer"
          >
            <el-link
              size="mini"
              :underline="false"
              @click="column.expanded = !column.expanded"
            >
              {{ !column.expanded ? $t('components.collapse') : $t('grid.others.more') }}
            </el-link>
          </div>
        </div>
      </div>
    </template>
    <slot />
  </div>
</template>

<script>
import moment from 'moment'
import '../../../../lib/styles/components/FilterForm.scss'

function throttle(func, threshhold = 160, immediate = true) {
  let timeout
  let start = new Date()
  return function() {
    const context = this
    const args = arguments
    const curr = new Date() - 0

    clearTimeout(timeout)

    if (curr - start >= threshhold) {
      func.apply(context, args)
      start = curr
    } else {
      if (immediate) {
        timeout = setTimeout(function() {
          func.apply(context, args)
        }, threshhold)
      }
    }
  }
}

export default {
  name: 'FilterForm',
  props: {
    localStorageKey: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      filterForm: this.createFilterForm(this.dataSource),
      heightList: [],
      flag: true,
      hasLocalSotrage: false,
      showfilterItems: true,
      showfilter: false
    }
  },
  computed: {
    isSelect() {
      return function(column, row) {
        const {
          valueKey,
          sourceValue,
          sourceName
        } = column
        return this.filterForm[valueKey] && this.filterForm[valueKey].length
          ? this.filterForm[valueKey].some(item =>
            item[sourceValue] === row[sourceValue] &&
            item[sourceName] === row[sourceName]
          )
          : false
      }
    },
    selectedList() {
      return Object.keys(this.filterForm)
        .map(key => {
          return this.filterForm[key].length && key.split(',').length < 2
            ? this.filterForm[key]
            : null
        })
        .flat()
        .filter(item => item)
        .sort((a, b) => a.dateKey - b.dateKey)
    }
  },
  watch: {
    dataSource: {
      handler() {
        this.$nextTick(() => {
          if (this.flag) {
            this.getItemHeight()
          }
          this.flag = false
        })
      },
      deep: true
    }
  },
  mounted() {
    this.loadFilterForm()
    this.setHasLocalStorage()
    window.addEventListener('resize', this.getItemHeight, false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getItemHeight)
  },
  methods: {
    handleChangeTime(val, key) {
      this.filterForm[key.toString()] = val.length ? [
        moment(val[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        moment(val[1]).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
      ] : []
      this.$emit('handleChange')
    },
    getItemHeight: throttle(function() {
      const nodeList = this.$refs.columnWrapper || []
      if (nodeList.length) {
        nodeList.forEach((node, index) => {
          setTimeout(() => {
            const height = node.clientHeight
            if (height > 38) {
              // eslint-disable-next-line vue/no-mutating-props
              this.dataSource[index].expanded = true
            }
            this.heightList.push(height)
          }, 0)
        })
        this.showfilter = true
      } else {
        this.showfilter = false
      }
    }),
    multipleDelte(target) {
      const index = this.filterForm[target.columnKey].findIndex(item => {
        return item[item.sourceValue] === target[target.sourceValue] &&
            item[item.sourceName] === target[target.sourceName]
      })

      this.filterForm[target.columnKey].splice(index, 1)
      this.$emit('handleChange')
    },
    setHasLocalStorage() {
      const localFilterForm = JSON.parse(localStorage.getItem(this.localStorageKey))
      this.hasLocalSotrage = !!localFilterForm
    },
    loadFilterForm() {
      const localFilterForm = JSON.parse(localStorage.getItem(this.localStorageKey))
      if (localFilterForm) {
        this.filterForm = localFilterForm
      }
    },
    clearFilterForm() {
      this.filterForm = this.createFilterForm(this.dataSource)
      this.$emit('handleChange')
    },
    saveFilterForm() {
      if (this.hasLocalSotrage) {
        localStorage.removeItem(this.localStorageKey)
      } else {
        if (Object.keys(this.filterForm).every(key => !this.filterForm[key].length)) {
          this.$message.warning(this.$t('grid.others.noFilterConditionsselectAndSave'))
        } else {
          this.$message.success(this.$t('grid.others.savedFilterConditions'))
          localStorage.setItem(this.localStorageKey, JSON.stringify(this.filterForm))
        }
      }
      this.setHasLocalStorage()
    },
    handleSelect(selected, row, target, refKey) {
      if (selected) {
        if (!target.isMultiple) {
          target.dataSource.map(item => {
            this.$refs[item[target.sourceValue] + item[target.sourceName]][0].effect = 'light'
          })
        }
        this.$refs[refKey][0].effect = 'dark'
      } else {
        this.$refs[refKey][0].effect = 'light'
      }
      if (selected) {
        if (target.isMultiple) {
          this.filterForm[target.valueKey].push({
            sourceName: target.sourceName,
            sourceValue: target.sourceValue,
            dateKey: new Date().getTime(),
            columnKey: target.valueKey,
            ...row
          })
        } else {
          this.$set(this.filterForm[target.valueKey], 0, {
            sourceName: target.sourceName,
            sourceValue: target.sourceValue,
            dateKey: new Date().getTime(),
            columnKey: target.valueKey,
            ...row
          })
        }
      } else {
        this.filterForm[target.valueKey] = this.filterForm[target.valueKey].filter(item =>
          item[target.sourceValue] !== row[target.sourceValue] ||
          item[target.sourceName] !== row[target.sourceName]
        )
      }
      this.$emit('handleChange', selected, row, target)
    },
    createFilterForm(list) {
      const obj = {}
      list.forEach(item => {
        if (item.type === 'date') {
          if (item.defaultValue) {
            obj[item.valueKey.toString()] = item.defaultValue
          } else {
            obj[item.valueKey.toString()] = []
          }
        } else {
          // obj[item.valueKey] = item.isMultiple ? [] : undefined
          if (item.defaultValue) {
            const defaultAry = []
            item.defaultValue.map(defaultItem => {
              defaultAry.push({
                columnKey: item.valueKey,
                sourceValue: item.sourceValue,
                sourceName: item.sourceName,
                dateKey: new Date().getTime(),
                ...defaultItem
              })
            })
            obj[item.valueKey] = [].concat(defaultAry)
          } else {
            obj[item.valueKey] = []
          }
        }
      })
      return obj
    },
    getFormValue() {
      const formData = Object.assign({}, this.filterForm)

      return this.dataSource.reduce((prev, next) => {
        if (next.type === 'date') {
          next.valueKey.forEach((item, index) => {
            prev[item] = formData[next.valueKey.toString()][index]
          })
        } else {
          if (next.sourceType === 'origin') {
            prev[next.valueKey] = formData[next.valueKey]
          } else {
            prev[next.valueKey] = formData[next.valueKey].map(item =>
              !next.sourceType ? item[next.sourceValue] : item[next.sourceName]
            ).toString()
          }
        }
        return prev
      }, {})
    }
  }
}
</script>
